import SimpleQuestion from "./SimpleQuestion";
import * as theme from "../theme";
import Select from "react-dropdown-select";
import { useDispatch, useSelector } from "react-redux";
import {
  getGmapPostalCodeData,
  getGmapPredictions,
  getGoogleMapPostalCode,
  getGoogleMapPredictions,
  gmapPostalCodeSucceed,
} from "../store/qf";
import { useEffect, useState } from "react";
import SelectDropdown from "react-select";
import _ from "lodash";
import { addressParts } from "../store/businesslogic/hwlHelper";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import {
  getBrokerInformation,
  retrieveBrokerageImg,
  retrieveBrokerforClient,
} from "../store/broker";
import translations from "../utils/translations";
const Address = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  return (
    <SimpleQuestion
      leftString={text}
      node={node}
      alignCenter={"No"}
      rightComponent={
        <AddressInput
          node={node}
          handleAnswerChange={handleAnswerChange}
          qfusermode={qfusermode}
        ></AddressInput>
      }
    ></SimpleQuestion>
  );
};

const DropdownRenderer = ({ props, state, methods }) => {
  const dispatch = useDispatch();

  const gmapPredictions = useSelector(getGmapPredictions);

  useEffect(() => {
    dispatch(getGoogleMapPredictions({ query: state.search }));
  }, [state.search, dispatch]);

  let rows = gmapPredictions.map((item, index) => (
    <EachRowAddressRender
      index={index}
      item={item}
      methods={methods}
    ></EachRowAddressRender>
  ));

  return (
    <div style={{ border: 0 }}>
      <div style={{ border: 0 }}>{rows}</div>
    </div>
  );
};

const EachRowAddressRender = ({ index, methods, item }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      key={index}
      style={{
        marginBottom: "1vh",
        color: theme.COLORS.primary_navyblue,
        padding: "1vh",
        backgroundColor: hover ? theme.COLORS.secondary_orange : "inherit",
      }}
      onClick={() => {
        methods.addItem(item);
      }}
      onMouseOver={() => {
        setHover(true);
      }}
      onMouseOut={() => {
        setHover(false);
      }}
    >
      {item.description}
    </div>
  );
};

const AddressInput = ({ node, handleAnswerChange, qfusermode }) => {
  const gmapPredictions = useSelector(getGmapPredictions);
  const gmapPostalCodeAPIData = useSelector(getGmapPostalCodeData);
  const [selectedPlaceId, setSelectedPlaceId] = useState(null); // Track the specific place_id to avoid race conditions
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  const dispatch = useDispatch();

  const onChangeHandle = (values) => {
    if (!_.isEmpty(values)) {
      let valueSelected = values[0];
      if (valueSelected?.place_id) {
        // Store the place_id to identify this component's request
        setSelectedPlaceId(valueSelected.place_id);
        // call the api to get the postalcode
        dispatch(getGoogleMapPostalCode({ query: valueSelected.place_id }));
      } else if (values.value) {
        setSelectedPlaceId(values.value);
        dispatch(getGoogleMapPostalCode({ query: values.value }));
      }
    }
  };

  const onChangeHandle2 = (values) => {
    dispatch(getGoogleMapPredictions({ query: values }));
  };

  const getUpdatedAnswerObject = (answerObject) => {
    // Add defensive checks for malformed API responses
    if (!answerObject?.detail?.result) {
      console.warn('Invalid Google Places API response structure:', answerObject);
      return answerObject;
    }

    let addresscomponents = answerObject.detail.result.address_components;

    if (!_.isEmpty(addresscomponents) && Array.isArray(addresscomponents)) {
      // Initialize address parts to avoid undefined concatenations
      let streetNumber = '';
      let route = '';
      
      addresscomponents.forEach((element) => {
        // Defensive check for element structure
        if (!element || !element.types || !Array.isArray(element.types)) {
          console.warn('Invalid address component:', element);
          return;
        }
        
        // Check all types, not just the first one
        const types = element.types;
        const longName = element.long_name || '';
        const shortName = element.short_name || '';
        
        // Use a priority system for overlapping types
        if (types.includes("country")) {
          answerObject[addressParts.country] = longName;
        }
        if (types.includes("postal_code")) {
          answerObject[addressParts.postalcode] = longName;
        }
        if (types.includes("street_number")) {
          streetNumber = longName;
          answerObject[addressParts.streetNumber] = longName;
        }
        if (types.includes("route")) {
          route = longName;
          answerObject[addressParts.street] = longName;
        }
        // Handle province/state with multiple possible type names
        if (types.includes("administrative_area_level_1")) {
          answerObject[addressParts.province] = longName;
        }
        // Handle city/town with multiple possible type names
        if (types.includes("locality") || types.includes("sublocality") || types.includes("sublocality_level_1")) {
          answerObject[addressParts.town] = longName;
        }
        // Fallback for areas that might be in different administrative levels
        if (!answerObject[addressParts.town] && types.includes("administrative_area_level_2")) {
          answerObject[addressParts.town] = longName;
        }
      });
      
      // Build street1 after processing all components to ensure proper order
      if (streetNumber || route) {
        answerObject[addressParts.street1] = `${streetNumber} ${route}`.trim();
      }
    } else {
      console.warn('No valid address components found in API response');
    }
    return answerObject;
  };

  const handleExplicitAddressChange = (key, value) => {
    if (
      node.answer === "" ||
      node.answer === null ||
      node.answer === undefined ||
      _.isEmpty(node.answer)
    ) {
      handleAnswerChange({ [key]: value });
    } else {
      handleAnswerChange({ ...node.answer, [key]: value });
    }
    if (key == "street1") {
      try {
        let unitNumber = value.split(" ")[0];
        let valueArr = value.split(" ");
        valueArr.shift();
        let street = valueArr.join(" ");
        //console.log({ ...node.answer, [key]: value, 'streetNumber': unitNumber, "street": street })
        handleAnswerChange({
          ...node.answer,
          [key]: value,
          streetNumber: unitNumber,
          street: street,
        });
      } catch (e) {
        console.log(e);
      }
    }
  };

  useEffect(() => {
    let answerObject = {};
    if (!_.isEmpty(gmapPostalCodeAPIData) && selectedPlaceId) {
      // Check if this response is for the place_id this component requested
      const responseForThisComponent = 
        gmapPostalCodeAPIData?.result?.place_id === selectedPlaceId ||
        gmapPostalCodeAPIData?.query === selectedPlaceId;
      
      if (responseForThisComponent) {
        answerObject = {
          detail: gmapPostalCodeAPIData,
        };

        answerObject = getUpdatedAnswerObject(answerObject);
        handleAnswerChange(answerObject);
        dispatch(gmapPostalCodeSucceed({}));
        setSelectedPlaceId(null); // Reset after processing
      }
    }
  }, [gmapPostalCodeAPIData, handleAnswerChange, dispatch, selectedPlaceId]);
  // const dispatch = useDispatch();
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ marginBottom: "15px" }} tabIndex={2}>
        <SelectDropdown
          // className="form-select"
          placeholder={translations[languagepreference].address.autofill}
          options={gmapPredictions.map((x) => {
            return { label: x.description, value: x.place_id };
          })}
          onInputChange={(values) => onChangeHandle2(values)}
          onChange={(values) => onChangeHandle(values)}
          labelField={`description`}
          valueField={"id"}
          isSearchable={true}
          noOptionsMessage={() => translations[languagepreference].address.noOptions}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              width: "100%",
              minHeight: "3vh",
              fontSize: "1.3vmin",
              borderRadius: 7,
              border: 0,
              fontFamily: "GibsonRegular",
              backgroundColor: theme.COLORS.secondary_orange,
              padding: "1vh",
              wordWrap: "break-word",
              color: "white",
            }),
            menuList: (baseStyles, state) => ({
              ...baseStyles,
              backgroundColor: theme.COLORS.tertiary_ligthindigo,
            }),
          }}
        />
      </div>
      <div style={{ padding: "0.5vh", paddingLeft: 0 }}>
        <input
          type="text"
          placeholder={
            translations[languagepreference].address.correspondenceLine1
          }
          id={"line1" + node.id}
          style={{ ...theme.inputStyle }}
          value={node.answer?.street1 ? node.answer.street1 : ""}
          onChange={(e) => {
            handleExplicitAddressChange(addressParts.street1, e.target.value);
          }}
          readOnly={qfusermode === INSURER ? true : false}
        ></input>
      </div>
      <div style={{ padding: "0.5vh", paddingLeft: 0 }}>
        <input
          type="text"
          placeholder={
            translations[languagepreference].address.correspondenceLine2
          }
          id={"line2" + node.id}
          style={{ ...theme.inputStyle }}
          value={node.answer?.unitNumber ? node.answer.unitNumber : ""}
          onChange={(e) => {
            handleExplicitAddressChange(
              addressParts.unitNumber,
              e.target.value
            );
          }}
          readOnly={qfusermode === INSURER ? true : false}
        ></input>
      </div>
      <div style={{ padding: "0.5vh", paddingLeft: 0 }}>
        <input
          type="text"
          placeholder={translations[languagepreference].address.city}
          id={"line2" + node.id}
          style={{ ...theme.inputStyle }}
          value={node.answer?.town ? node.answer.town : ""}
          onChange={(e) => {
            handleExplicitAddressChange(addressParts.town, e.target.value);
          }}
          readOnly={qfusermode === INSURER ? true : false}
        ></input>
      </div>
      <div style={{ padding: "0.5vh", paddingLeft: 0 }}>
        <input
          type="text"
          placeholder={translations[languagepreference].address.province}
          id={"province" + node.id}
          style={{ ...theme.inputStyle }}
          value={node.answer?.province ? node.answer.province : ""}
          onChange={(e) => {
            handleExplicitAddressChange(addressParts.province, e.target.value);
          }}
          readOnly={qfusermode === INSURER ? true : false}
        ></input>
      </div>
      <div style={{ padding: "0.5vh", paddingLeft: 0 }}>
        <input
          type="text"
          placeholder={translations[languagepreference].address.country}
          id={"country" + node.id}
          style={{ ...theme.inputStyle }}
          value={node.answer?.country ? node.answer.country : ""}
          onChange={(e) => {
            handleExplicitAddressChange(addressParts.country, e.target.value);
          }}
          readOnly={qfusermode === INSURER ? true : false}
        ></input>
      </div>
      <div style={{ padding: "0.5vh", paddingLeft: 0 }}>
        <input
          type="text"
          placeholder={translations[languagepreference].address.postalCode}
          id={"postalcode" + node.id}
          style={{ ...theme.inputStyle }}
          value={node.answer?.postalcode ? node.answer.postalcode : ""}
          onChange={(e) => {
            handleExplicitAddressChange(
              addressParts.postalcode,
              e.target.value
            );
          }}
          readOnly={qfusermode === INSURER ? true : false}
        ></input>
      </div>
    </div>
  );
};

export default Address;
